import request from '@/utils/request'

// 党建
export function getSingleArticle(params) {
	return request({
		url: '/jeecg-boot/index/singleArticle',
		method: 'GET',
		params: params
	})
}